<template>
  <PropertyTypeTable class="content-block"></PropertyTypeTable>
</template>

<script>
import PropertyTypeTable from 'CORE/components/property-type/table'

export default {
    name: 'PropertyTypeList',
    components: {
        PropertyTypeTable,
    },
}
</script>
